import { fetchIconicStoriesActionCreator, ICONIC_STORIES_FILTER_CHANGED } from '../actions';
import {
  getActiveIconicStoriesFilterIds,
  getContentApiUrl,
  getIconicStoriesPage,
  getIconicStoriesPageSize,
  getIconicStoriesSliceFilterId,
  isIconicStoriesBusy,
} from '../selectors';
import fetchJson from './fetchJson';
import createFetchOnHydrationMiddleware from './createFetchOnHydrationMiddleware';
import composeMiddlewares from '../helpers/composeReduxMiddlewares';

const dispatchFetchIconicStories = (store, filterId) => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);
  const pageSize = getIconicStoriesPageSize(state, filterId);
  store.dispatch(fetchIconicStoriesActionCreator(
    filterId,
    fetchJson(
      'tiles',
      [apiUrl, 'stories', filterId].join('/'),
      { pageSize },
    ),
  ));
};

const handleFilterChanged = (store, sliceId) => {
  const state = store.getState();
  if (!isIconicStoriesBusy(sliceId) && !getIconicStoriesPage(state, sliceId)) {
    const filterId = getIconicStoriesSliceFilterId(state, sliceId);
    dispatchFetchIconicStories(store, filterId);
  }
};

export default composeMiddlewares(
  createFetchOnHydrationMiddleware(
    getActiveIconicStoriesFilterIds,
    dispatchFetchIconicStories,
  ),
  store => next => action => {
    const ret = next(action);
    if (action.type === ICONIC_STORIES_FILTER_CHANGED) {
      handleFilterChanged(store, action.meta.sliceId);
    }
    return ret;
  },
);
